import { PPRD, Text } from "@/components";
import { Fragment } from "react";

export const ServiceHighlights = () => {
  return (
    <div className="bg-black py-12 md:py-16">
      <div className="grid xl:grid-cols-2 container mx-auto gap-y-6 xl:gap-y-8">
        <Text.Heading>
          <div className="flex xl:flex-col justify-center">
            <div className="text-white">Service&nbsp;</div>
            <div className="text-secondary">Highlights</div>
          </div>
        </Text.Heading>

        <div className="flex items-center justify-center">
          <PPRD />
        </div>

        <div className="flex flex-col md:flex-row xl:flex-col gap-6">
          {[
            {
              gifSrc: "/images/3-leaves-clover.gif",
              title: "End-to-End Management",
              text: "Onboarding, adding cap table members, generating reports, running dilution or exit simulations, we handle it all.",
            },
            {
              gifSrc: "/images/fingerprint-security.gif",
              title: "Data Privacy",
              text: "We will never spam your investors.",
            },
          ].map(({ gifSrc, title, text }) => (
            <div
              className="flex-1 flex flex-col xl:flex-row items-center gap-4"
              key={title}
            >
              <img className="w-20 h-20" src={gifSrc} alt={title} />

              <div className="w-full flex flex-col gap-2.5">
                <div className="text-center xl:text-left text-[28px] text-white font-medium">
                  {title}
                </div>
                <div className="text-center xl:text-left">{text}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col md:flex-row xl:flex-col gap-6">
          {[
            {
              gifSrc: "/images/bar-chart.gif",
              title: "Cap Table Included",
              text: "All of the information is still at your fingertips. Log in to see the status of your cap table. And get your hands dirty making updates yourself if you like.",
            },
            {
              gifSrc: "/images/clock-time.gif",
              title: "24 hr turnaround",
              text: "We know how fast you need to move; we are here for you when you need it most. After request you will receive an initial response within 24 hours.",
            },
          ].map(({ gifSrc, title, text }) => (
            <div
              className="flex-1 flex flex-col xl:flex-row items-center gap-4"
              key={title}
            >
              <img className="w-20 h-20" src={gifSrc} alt={title} />

              <div className="w-full flex flex-col gap-2.5">
                <div className="text-center xl:text-left text-[28px] text-white font-medium">
                  {title}
                </div>
                <div className="text-center xl:text-left">{text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
